import React, { useState } from "react";
import { Drawer, IconButton } from "@mui/material";
import Link from "next/link";
import { useMediaQuery } from "usehooks-ts";
import { ChevrondownSvg, CrossBlackIcon } from "@/src/Asset";
// import Icon from "@/src/Utils/Icons/Icons";

interface TopExploreSectionProps {
  title: string;
  data: any[];
  linkPrefix: string;
  linkSuffix?: string;
  className?: string;
  textColor?: string;
}

const TopExploreSection: React.FC<TopExploreSectionProps> = ({
  title,
  data,
  linkPrefix,
  linkSuffix,
  className = "bg-white relative",
  textColor = "text-black",
}) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer = (open: boolean) => {
    setIsDrawerOpen(open);
  };
  const isLargeScreen = useMediaQuery("(min-width: 1024px)");
  const displayItems = isLargeScreen ? 8 : 3;

  return (
    <div
      className={`mt-16 lg:mt-24 text-xs z-[99] w-full h-fit lg:px-5 2xl:px-10 2xl:max-w-full 3xl:max-w-screen-3xl 3xl:mx-auto ${className}`}
    >
      {/* Top bar */}
      <div className="flex items-center py-1 px-4 justify-between">
        <div className="flex items-center gap-x-4">
          <p
            className={`font-medium border-r pr-4 border-r-gray-500 ${textColor}`}
          >
            <span className="hidden lg:inline-block">Browse</span> {title}
          </p>
          {data?.slice(0, displayItems).map((item: any, index: number) => {
            const url = linkSuffix
              ? `${linkPrefix}/${item?.url}${linkSuffix}`
              : `${linkPrefix}/${item?.url?.toLowerCase()}`;
            return (
              <Link href={url} key={item?.id + index}>
                <p className={`hover:underline ${textColor}`}>{item?.name}</p>
              </Link>
            );
          })}
        </div>
        <button
          className={`text-primary-black font-medium pr-1 lg:pr-5 ${textColor}`}
          onClick={() => toggleDrawer(true)}
        >
          More <ChevrondownSvg className="inline scale-75" />
          {/* <Icon
            name="PiCaretRightThin"
            className={`inline-block text-lg rotate-90 ${textColor}`}
          /> */}
        </button>
      </div>
      <Drawer
        anchor="right"
        open={isDrawerOpen}
        onClose={() => toggleDrawer(false)}
        className="!z-[899]"
        PaperProps={{
          className: "w-64 mt-[3.5rem] lg:mt-[5.5rem]",
        }}
      >
        <div className="p-4 relative">
          <IconButton
            onClick={() => toggleDrawer(false)}
            className="text-black !absolute right-2"
          >
            <CrossBlackIcon className="w-5 h-5" />
          </IconButton>
          <p className="text-lg lg:text-xl font-semibold mb-4 border-b pb-4 mt-1.5">
            {title}
          </p>
          <div className="flex gap-y-2 flex-col pb-20">
            {data?.map((item: any) => {
              const url = linkSuffix
                ? `${linkPrefix}/${item?.url}${linkSuffix}`
                : `${linkPrefix}/${item?.url?.toLowerCase()}`;
              return (
                <Link
                  href={url}
                  key={item?.id}
                  onClick={() => toggleDrawer(false)}
                >
                  <p
                    className={`hover:underline text-gray-500 hover:text-primary text-sm lg:text-base line-clamp-1`}
                  >
                    {item?.name}
                  </p>
                </Link>
              );
            })}
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default TopExploreSection;
